import React, { useState, useEffect } from 'react';
import api from '../services/api';

// PENDING LIMIT ORDERS with Edit / Cancel (owner 2026-10-23: "i can also edit limit on all sides").
// Shown on the Watchlist (where limit BUYs are placed); the Dashboard has the same controls next to positions.
// Keeps the last good list on a failed poll (no flicker).
export default function PendingOrders({ onResult }) {
  const [orders, setOrders] = useState([]);
  const [edit, setEdit] = useState(null);   // { id, px, n, lot }
  const load = async () => {
    try { const r = await api.getPendingOrders(); if (r && r.status === 'success') setOrders(r.orders || []); } catch (e) { /* keep last */ }
  };
  useEffect(() => {
    let alive = true;
    const q = async () => { if (alive) await load(); };
    q(); const iv = setInterval(q, 4000);
    return () => { alive = false; clearInterval(iv); };
  }, []);
  const say = (r, ok) => onResult && onResult(r && r.status === 'success' ? 'success' : 'error', (r && r.message) || ok);
  const save = async () => {
    const px = parseFloat(edit.px);
    if (!(px > 0)) return;
    try {
      const r = await api.modifyPendingOrder(edit.id, px, Math.max(1, (edit.lot || 1) * (parseInt(edit.n, 10) || 0)));
      say(r, 'Changed');
      if (r && r.status === 'success') setEdit(null);
    } catch (e) { onResult && onResult('error', 'Edit failed — server not reachable'); }
    load();
  };
  const cancel = async (id) => {
    try { say(await api.cancelPendingOrder(id), 'Cancelled'); } catch (e) { /* ignore */ }
    load();
  };
  if (!orders.length) return null;
  return (
    <div className="card full-width" style={{ border: '1px solid #ffb020', marginBottom: '0.8rem' }}>
      <div style={{ color: '#ffb020', fontWeight: 700, fontSize: '0.85rem', marginBottom: 4 }}>Pending limit orders ({orders.length})</div>
      {orders.map(o => (
        <div key={o.id} style={{ display: 'flex', gap: '0.6rem', alignItems: 'center', flexWrap: 'wrap', fontSize: '0.78rem', padding: '3px 0' }}>
          <b style={{ color: o.kind === 'entry' ? '#00ff88' : '#ff6b6b' }}>{o.kind === 'entry' ? 'BUY' : 'SELL'}</b>
          <span>{o.trade_symbol} ×{o.qty}</span>
          <span>@ ₹{o.limit}</span>
          <span style={{ color: '#888' }}>({o.mode}{o.uid ? ` · ${o.uid}` : ''}, placed at ₹{o.ltp_at_order})</span>
          <button className="btn" style={{ fontSize: '0.65rem', padding: '0.1rem 0.45rem' }}
            onClick={() => { const lot = +o.lot > 0 && o.qty % o.lot === 0 ? +o.lot : 0; setEdit({ id: o.id, px: String(o.limit), n: lot ? Math.round(o.qty / lot) : o.qty, lot }); }}>Edit</button>
          <button className="btn" style={{ fontSize: '0.65rem', padding: '0.1rem 0.45rem' }} onClick={() => cancel(o.id)}>Cancel</button>
          {edit && edit.id === o.id && (
            <div style={{ display: 'flex', gap: '0.4rem', alignItems: 'center', flexWrap: 'wrap', width: '100%', padding: '4px 0 4px 1rem' }}>
              <span>Price ₹</span>
              <input type="number" step="0.05" min="0" value={edit.px} style={{ width: 80 }} onChange={e => setEdit({ ...edit, px: e.target.value })} />
              <span>Quantity</span>
              <input type="number" min={edit.lot || 1} step={edit.lot || 1} value={(edit.lot || 1) * (parseInt(edit.n, 10) || 0)} style={{ width: 80 }}
                onChange={e => { const l = edit.lot || 1; setEdit({ ...edit, n: Math.max(1, Math.round((parseInt(e.target.value, 10) || 0) / l)) }); }} />
              {edit.lot > 0 && <span style={{ color: '#888' }}>{edit.n} lot{edit.n > 1 ? 's' : ''} × {edit.lot}</span>}
              <button className="btn btn-start" style={{ fontSize: '0.65rem', padding: '0.1rem 0.5rem' }} onClick={save}>Save</button>
              <button className="btn" style={{ fontSize: '0.65rem', padding: '0.1rem 0.4rem' }} onClick={() => setEdit(null)}>✕</button>
              {o.mode === 'live' && <span style={{ color: '#888', fontSize: '0.68rem' }}>live: the old order is cancelled and a new one placed at your broker</span>}
            </div>)}
        </div>))}
    </div>
  );
}
